import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CalendarDays, Eye, ShoppingCart } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StoreBlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    fetch(`${API}/public/blog/${slug}`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((p) => {
        setPost(p);
        document.title = `${p.title} — Trustmeds Pharma Kashipur`;
        let meta = document.querySelector('meta[name="description"]');
        if (!meta) {
          meta = document.createElement("meta");
          meta.name = "description";
          document.head.appendChild(meta);
        }
        meta.setAttribute("content", p.excerpt || p.title);
      })
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="max-w-2xl mx-auto px-4 py-16 text-center" data-testid="blog-not-found">
        <h1 className="font-display text-2xl font-bold text-slate-900">Post nahi mili</h1>
        <Link to="/store/blog" className="mt-4 inline-flex items-center gap-2 text-emerald-700 font-semibold text-sm hover:underline">
          <ArrowLeft className="w-4 h-4" /> Blog par wapas jayein
        </Link>
      </div>
    );
  }

  if (!post) {
    return <div className="text-center py-16 text-slate-400 text-sm">Post load ho rahi hai…</div>;
  }

  return (
    <article className="max-w-3xl mx-auto px-4 py-8" data-testid="blog-post-page">
      <Link to="/store/blog" className="inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-700 hover:underline mb-4" data-testid="blog-back-link">
        <ArrowLeft className="w-3.5 h-3.5" /> Saare articles
      </Link>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 leading-tight">{post.title}</h1>
      <div className="mt-3 flex items-center gap-4 text-xs text-slate-400">
        <span className="inline-flex items-center gap-1"><CalendarDays className="w-3.5 h-3.5" /> {new Date(post.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</span>
        <span className="inline-flex items-center gap-1"><Eye className="w-3.5 h-3.5" /> {post.views} views</span>
      </div>
      {post.cover_image && (
        <img src={`${process.env.REACT_APP_BACKEND_URL}${post.cover_image}`} alt={post.title} className="w-full aspect-[2/1] object-cover rounded-3xl mt-5 border border-slate-100" />
      )}
      <div className="mt-6 text-slate-700 text-[15px] leading-relaxed whitespace-pre-line" data-testid="blog-post-content">{post.content}</div>
      <div className="mt-10 bg-emerald-50 border border-emerald-100 rounded-3xl p-6 text-center">
        <h3 className="font-display text-lg font-bold text-emerald-900">Medicines chahiye?</h3>
        <p className="text-sm text-emerald-700 mt-1">Kashipur mein same-day home delivery — genuine medicines, fair prices.</p>
        <Link to="/store/shop" data-testid="blog-shop-cta" className="mt-4 inline-flex items-center gap-2 bg-[#064E3B] hover:bg-[#043B2C] text-white font-semibold px-6 py-3 rounded-full text-sm">
          <ShoppingCart className="w-4 h-4" /> Abhi Order Karein
        </Link>
      </div>
    </article>
  );
}
